import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteProductSpecification($companyId: ID!, $id: ID!) {
    deleteProductSpecification(companyId: $companyId, id: $id) {
      productSpecification {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
